var LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
var LOCAL_STORAGE_DELIMITER = ',';
var BUTTON_ACTIVE_CLASS = 'active';
var GRID_LOADED_CLASS = 'loaded';

var selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
};

document.addEventListener('DOMContentLoaded', function () {
  initButtons();
  initGrid();
});
document.addEventListener('shopify-wishlist:reInit', function (event) {
  initButtons();
  initGrid();
});
document.addEventListener('shopify-wishlist:updated', function (event) {
  document.getElementById('wishlist-count').innerHTML = event.detail.wishlist.length;
  if(document.querySelectorAll('.mrk-wishlist-count').length){
    document.querySelector('.mrk-wishlist-count').innerHTML = event.detail.wishlist.length;
  }
  initGrid();
});

document.addEventListener('shopify-wishlist:init-product-grid', function (event) {
  document.getElementById('wishlist-count').innerHTML = event.detail.wishlist.length;
  if(document.querySelectorAll('.mrk-wishlist-count').length){
    document.querySelector('.mrk-wishlist-count').innerHTML = event.detail.wishlist.length;
  }
});

document.addEventListener('shopify-wishlist:init-buttons', function (event) {
  document.getElementById('wishlist-count').innerHTML = event.detail.wishlist.length;
  if(document.querySelectorAll('.mrk-wishlist-count').length){
    document.querySelector('.mrk-wishlist-count').innerHTML = event.detail.wishlist.length;
  }
});

var setupGrid = function (grid) {
  var wishlist = getWishlist();
  var requests = wishlist.map(function (handle) {
    var productTileTemplateUrl = window.langtext +'/products/' + handle + '?view=card';
    return fetch(productTileTemplateUrl).then(function (res) {
      return res.text();
    });
  });
  Promise.all(requests).then(function (responses) {
    var wishlistProductCards = responses.join('');
    grid.innerHTML = wishlistProductCards;
    grid.classList.add(GRID_LOADED_CLASS);
    initButtons();
    if(wishlist.length){
      document.querySelector('.mrk-filled-grid').style.display = 'block';
      document.querySelector('.mrk-empty-wishlist').style.display = 'none';
    }
    var event = new CustomEvent('shopify-wishlist:init-product-grid', {
      detail: { wishlist: wishlist }
    });
    document.dispatchEvent(event);
  });
};

var setupButtons = function (buttons) {
  buttons.forEach(function (button) {
    var productHandle = button.dataset.productHandle || false;
    if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
    if (wishlistContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);
    $(button).off('click').on('click', function() {
      updateWishlist(productHandle);
      $(button).toggleClass(BUTTON_ACTIVE_CLASS);
    });
  });
};

var initGrid = function () {
  var grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);
  var wishlist = getWishlist();
  if(wishlist != undefined && wishlist.length == 0){
    document.querySelector('.mrk-filled-grid').style.display = 'none';
    document.querySelector('.mrk-empty-wishlist').style.display = 'block';
  }
};

var initButtons = function () {
  var buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);
  else return;
  var event = new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() }
  });
  document.dispatchEvent(event);
};

var getWishlist = function () {
  var wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

var setWishlist = function (array) {
  var wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

  var event = new CustomEvent('shopify-wishlist:updated', {
    detail: { wishlist: array }
  });
  document.dispatchEvent(event);

  return wishlist;
};

var updateWishlist = function (handle) {
  var wishlist = getWishlist();
  var indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) wishlist.push(handle);
  else wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist);
};

var wishlistContains = function (handle) {
  var wishlist = getWishlist();
  return wishlist.indexOf(handle) !== -1;
};

var resetWishlist = function () {
  return setWishlist([]);
};